export default __webpack_public_path__ + "static/media/slide3.af426412.webp";